import { css } from 'react-emotion'

const styles = {
  component: css({
    position: 'relative',
    backgroundColor: '#000'
  }),
  video: css({
    width: '100%',
    height: '100%'
  }),
  controls: css({
    display: 'flex',
    backgroundColor: '#f5f5f5',
    transition: 'opacity 0.2s',
    borderLeft: '1px solid #e6e6e6',
    borderRight: '1px solid #e6e6e6',
  }),
  leftControls: css({
    display: 'flex',
    flex: '1',
    flexDirection: 'row',
    justifyContent: 'flex-start'
  }),
  middleControl: css({
    display: 'flex',
    flex: '1',
    justifyContent: 'center'
  }),
  rightControls: css({
    display: 'flex',
    flex: '1',
    justifyContent: 'flex-end'
  }),
  cursorPointer: css({
    cursor: 'pointer'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/VideoPlayerStyles.js